import React from 'react'
import { Row, Col } from 'antd';

const FooterContent = () => {
    return (
        <>
            <Row>
                <Col span={24}>
                    <Row type="flex" justify="center">
                        <Col span={6} className="txt-content">
                            <p className="txt-power-by">Powered by</p>
                        </Col>
                    </Row>
                    <Row type="flex" justify="center">
                        <Col lg={2} md={3} sm={5} xs={8}>
                            {/* eslint-disable-next-line */}
                            <a href="https://truevirtualworld.com">
                                {/* eslint-disable-next-line */}
                                <img src={process.env.PUBLIC_URL + '/img/logo_footer_tvw.png'} />
                            </a>
                        </Col>
                    </Row >
                </Col>
            </Row>
        </>
    )
}

export default FooterContent
